import { cn } from '../cn';
import WaveSpinner from './WaveSpinner';

type WaveSpinnerContainerProps = {
  message?: string;
};
export default function WaveSpinnerContainer({ message }: WaveSpinnerContainerProps) {
  return (
    <div
      className={cn(
        'text-zumthor-800 dark:bg-slate-900',
        'flex h-screen w-screen flex-col items-center justify-center',
      )}>
      <WaveSpinner />
      {message && <div className="mb-1">{message}</div>}
    </div>
  );
}
